

const SITE_KEY = '411998a29f2746b7737bccff0ee517bf'
const API_BASE_URL = 'https://live-vastu-backend.onrender.com/api';
let questions = [];
let currentQuestionIndex = 0;
let userAnswers = {
  session_id: sessionStorage.getItem('vastu_session_id') ? sessionStorage.getItem('vastu_session_id') : 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9)
    ,
    answers: []
};
let plans = [];
let userDetails = {};

// Fetch api data
async function initQuiz() {
    try {
       
        const propertyType = sessionStorage.getItem('vastu_property_type');
        const purpose = sessionStorage.getItem('vastu_purpose');

        if(!propertyType){
             window.location.href = '/pages/select-property';
        }
        else if(!purpose)
        {
            window.location.href = '/pages/purpose';
        }
        
        // Add to userAnswers
        userAnswers.property_type = propertyType;
        userAnswers.purpose = purpose;

        sessionStorage.setItem('vastu_session_id', userAnswers.session_id);
         
    //  let userExist =  await getUserReport(userAnswers.session_id);
    //  if(userExist)
    //  {
    //     return;
    //  }

        const response = await fetch(`${API_BASE_URL}/questions`,
            {
                headers: {
                        "x-site-key": SITE_KEY
                }
            }
        );
        const result = await response.json();

        let userPlan = sessionStorage.getItem('selected_plan') || 'bronze';
        
        if (result.success) {
            questions = result.data.filter(question => 
            question.question_plan === userPlan
        );
        console.log('userPlan ', userPlan);
        
           if (questions.length === 0) {
            document.getElementById('questionText').innerHTML = `No questions found for ${userPlan} plan`;
        }else{
             let typeDet =  await detailsType()
           if(typeDet && !sessionStorage.getItem('userDetails')) 
              await showUserDetailsForm()
           else
                showQuestion(0)
        }
            
            
        } else {
            document.getElementById('questionText').textContent = 'Error loading questions. Please try again.';
        }
    } catch (error) {
        console.error('Error loading questions:', error);
        document.getElementById('questionText').textContent = 'Error loading questions. Please try again.';
    }
}

async function getUserReport(sessionId)
{
 let response = await fetch(`${API_BASE_URL}/user-submissions/${sessionId}`,{
        headers:{
            "x-site-key": SITE_KEY
        } 
    })
    let result =await response.json();
    console.log("sdfsdf ",result)
    if(result.success)
    {
        sessionStorage.setItem('reportStatus', 'completed');
        showAIReport(result.data)
        return true;
        console.log(result.data)
    }
    sessionStorage.removeItem('reportStatus')
    return false;
}

// Show question 
function showQuestion(index) {
    if (index < 0 || index >= questions.length) return;

    document.querySelector('.top-header').children[0].innerHTML = 'Select Right Option to Get Your Vastu Report';
    
    currentQuestionIndex = index;
    const question = questions[index];
    
    // Update progress number
    document.getElementById('progressText').textContent = 
        `${currentQuestionIndex + 1}/${questions.length}`;
    
    // Display question
    document.getElementById('questionText').textContent = question.question_text;
    
    // Display options 
    const optionsContainer = document.getElementById('optionsContainer');
    optionsContainer.innerHTML = '';
    
    if (question.question_type === 'multiple_choice' && question.options) {
        
        // answer exist or not
        const existingAnswer = userAnswers.answers.find(
            answer => answer.question_id === question._id
        );
        
        question.options.forEach((option,optionIndex) => {
            const uniqueId = `q${currentQuestionIndex}_opt${optionIndex}`;
            
            const label = document.createElement('label');
            label.className = 'option-item';
            label.htmlFor = uniqueId; 
            // label.onclick = () => selectOption(option, label);
            
            // Create radio input
            const input = document.createElement('input');
            input.type = 'radio';
            input.name = 'direction';
            input.value = option;
            input.id = uniqueId; 
            label.onclick = (e) => 
            {
                e.preventDefault()
                selectOption(option, label);
            }
                
            
            if (existingAnswer && existingAnswer.answer === option) {
                input.checked = true;
                label.classList.add('selected');
            }
            
            // Create span for text
            const span = document.createElement('span');
            span.textContent = option;
            
           
            label.appendChild(input);
            label.appendChild(span);
            optionsContainer.appendChild(label);
        });
        
        
    }
    
    // Show prev button
    document.getElementById('prevBtn').style.display = index > 0 ? 'block' : 'none';
}


// function checkOptionSelected(question){
    
//  const isAnswered = userAnswers.answers.some(
//         answer => answer.question_id === question._id
//     );
//     document.getElementById('nextBtn').style.display = isAnswered ? 'block' : 'none';
// }

let isProcessing = false;

async function selectOption(option, labelElement) {
    if(isProcessing) return;
    isProcessing = true;
    // Remove selected class from all options
      document.querySelectorAll('.option-item').forEach(item => {
        item.classList.remove('selected');
    });
    
    // Add selected class to clicked option
    labelElement.classList.add('selected');
    
    // Check the radio button
    // const radioInput = labelElement.querySelector('input[type="radio"]');
    // radioInput.checked = true;
    
    const currentQuestion = questions[currentQuestionIndex];
    
    // Store answer with question data
    const answerData = {
        question_id: currentQuestion._id,
        question_text: currentQuestion.question_text,
        question_key: currentQuestion.question_key || "",
        answer: option,
        timestamp: new Date().toISOString()
    };
    
    // Check if we already have an answer for this question
    const existingAnswerIndex = userAnswers.answers.findIndex(
        answer => answer.question_id === currentQuestion._id
    );
    
    if (existingAnswerIndex !== -1) {
        // Update existing answer
        userAnswers.answers[existingAnswerIndex] = answerData;
    } else {
        // Add new answer
        userAnswers.answers.push(answerData);
    }
 
        setTimeout(async () => {
           isProcessing = false;
        if (currentQuestionIndex < questions.length - 1) {
           
            showQuestion(currentQuestionIndex + 1);
        } else {
            // All questions completed - Show mobile verification
            
               if (window.IS_LOGGED_IN) {
                userAnswers.email = window.CUSTOMER_EMAIL
                 saveDataAndCallOpenAI();
                
                } else {
                showMobileVerification();

                }
        }
    }, 500);

    
  
}

// Navigation functions
// function nextQuestion() {
//     if (currentQuestionIndex < questions.length - 1) {
//         showQuestion(currentQuestionIndex + 1);
//     } else {
//         // All questions answered
        
//         alert('All questions completed!');
//          showMobileVerification();
//     }
// }

function prevQuestion() {
    if (currentQuestionIndex > 0) {
        showQuestion(currentQuestionIndex - 1);
    }
}

function showMobileVerification() {
    // Hide quiz section
    document.getElementById('questionContainer').style.display = 'none';
    document.getElementById('prevBtn').style.display = 'none';
    // document.getElementById('nextBtn').style.display = 'none';
    
    // Show mobile verification
    document.getElementById('mobileVerification').style.display = 'block';
    
    
}


async function submitEmailForm() {

    

    const email = document.getElementById('emailId').value.trim();

    if (!email || !email.includes("@")) {
        alert("Please enter a valid email address");
        return;
    }
    
    userAnswers.email = email;
    
    try {
        const res = await fetch(`${API_BASE_URL}/user-submissions/send-email-otp`, {
            method: "POST",
            headers: { "Content-Type": "application/json","x-site-key": SITE_KEY },
            body: JSON.stringify({ email })
        });

        const data = await res.json();

        if (!data.success) {
            alert(data.message || "Failed to send OTP");
            return;
        }

        alert(data.message);
        document.getElementById("otpSection").style.display = "block";

    } catch (err) {
        console.error(err);
        alert("Something went wrong while sending OTP");
    } 
    
}

document.getElementById('emailForm').addEventListener('submit', (e)=>{
     e.preventDefault();
    submitEmailForm(e)
});


document.getElementById('resendBtn').addEventListener('click', (e)=>{
   
    submitEmailForm()
});








async function verifyOTP() {
    const otp = document.getElementById('otpCode').value.trim();
     const email = document.getElementById('emailId').value.trim();

      if (!otp || otp.length !== 6) {
        alert("Please enter a valid 6-digit OTP");
        return;
    }
    
    // Basic validation
    if (!email || !email.includes("@")) {
        alert('Please enter a valid email');
        return;
    }

     userAnswers.email = email;
  
       
        try {
        
         const res = await fetch(`${API_BASE_URL}/user-submissions/verify-email-otp`, {
            method: "POST",
            headers: { "Content-Type": "application/json","x-site-key": SITE_KEY },
            body: JSON.stringify({
                email: userAnswers.email,
                otp: otp
            })
        });

        const data = await res.json();

        if (!data.success) {
            alert(data.message || "Invalid OTP");
            return;
        }

        alert(data.message);
        if(data.success)
        {
              document.getElementById('mobileVerification').style.display = 'none';
                 saveDataAndCallOpenAI();
        }
       

    } catch (error) {
        console.error(error);
        alert("Something went wrong while verifying otp.");
    }
    
}

async function detailsType(){
    const response = await fetch(`${API_BASE_URL}/form-type`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                      "x-site-key": SITE_KEY
                }
            });
            const result = await response.json();
            if(result.success && result.formType == 'basic')
            {
                return true;
            }
            else{
                return false;
            }
            return false;
}

// collect user details section code

async function showUserDetailsForm() {
    
    document.querySelector(".vastu-form").style.display = "block";
    const sections = document.querySelectorAll(".section");
    let currentStep = 0;
document.querySelector('.top-header').children[0].innerHTML = 'Fill in your personal details to get Vastu Report'

function showSection(index) {
  sections.forEach((sec, i) => {
    sec.classList.toggle("active", i === index);
  });
}

// Error functions
function showUserDetailsError(input, message) {
  const field = input.closest(".field");
  field.querySelector(".error").innerText = message;
  input.classList.add("error-border");
  console.log("input")
}

function clearError(input) {
  const field = input.closest(".field");
  field.querySelector(".error").innerText = "";
  input.classList.remove("error-border");
}

// Validation
function validateSection(step) {
  let valid = true;
  const inputs = sections[step].querySelectorAll("input, select");

  inputs.forEach(input => {
    clearError(input);
    if (input.hasAttribute("required") && !input.value.trim()) {
      showUserDetailsError(input, "Required");
      valid = false;
    }
  });

  // Custom
  if (step === 0) {
    const name = document.querySelector("[name='name']");
    if (name.value.length < 3) {
      showUserDetailsError(name, "Min 3 chars");
      valid = false;
      
    }
    // 2. Phone Validation (Required + 10 Digits Check)
    const phone = document.querySelector("[name='phone']");
    if (phone) {
      const phoneValue = phone.value.trim();
      const phoneRegex = /^[6-9]\d{9}$/; // Validates Indian 10-digit mobile numbers

      if (!phoneValue) {
        showUserDetailsError(phone, "Phone number is required");
        valid = false;
      } else if (!phoneRegex.test(phoneValue)) {
        showUserDetailsError(phone, "Enter a valid 10-digit number");
        valid = false;
      }
    }
  }

  if (step === 1) {
    const area = document.querySelector("[name='area']");
    if (area.value < 100) {
      showUserDetailsError(area, "Min 100 sq ft");
      valid = false;
    }
  }

  if (step === 2) {
    const members = +document.querySelector("[name='members']").value || 0;
    const adults = +document.querySelector("[name='adults']").value || 0;
    const children = +document.querySelector("[name='children']").value || 0;
    const elders = +document.querySelector("[name='elders']").value || 0;

    if (members !== (adults + children + elders)) {
      showUserDetailsError(document.querySelector("[name='members']"), "Mismatch");
      valid = false;
    }
    console.log(adults + children + elders);
    
  }

  return valid;
}

// Buttons
document.querySelectorAll(".next-btn").forEach(btn => {
  btn.onclick = () => {
    if (!validateSection(currentStep)) return;
    currentStep++;
    showSection(currentStep);
  };
});

document.querySelectorAll(".prev-btn").forEach(btn => {
  btn.onclick = () => {
    currentStep--;
    showSection(currentStep);
  };
});

// Submit
document.getElementById("vastuForm").addEventListener("submit",async function(e) {
  e.preventDefault();
  if (!validateSection(currentStep)) return;


  const form = this;
  console.log('form ',form);
  
  const formData = new FormData(form);
  console.log('formdata ',formData);
  
  let data = {};

  formData.forEach((value, key) => {
    data[key] = value.trim();
  });

   // Save data
  userDetails = data;
  console.log("user details",userDetails);
  sessionStorage.setItem('userDetails',JSON.stringify(userDetails))
   alert("Your Details have been stored with us. Press ok to proceed.");
   document.querySelector(".vastu-form").style.display = "none";
   document.querySelector("#questionText").innerHTML = 'Loading Questions...'
   document.querySelector(".quiz-navigation").style.display = 'block';

   showQuestion(0);
});
            
            


}

// After successful OTP verification
async function saveDataAndCallOpenAI() {
    try {
          sessionStorage.setItem('reportStatus','processing');

            console.log('Saving user data to database');
        document.getElementById('mobileVerification').style.display = 'none';
        document.getElementById('questionContainer').style.display = 'block';
  const loadingData= `<div class="report-container">
            <h2>Our expert is analyzing your data. Your personalized vastu report is generating...</h2>
                <p class="processing-note">This may take 10-15 minutes.</p>
                <p class="processing-note">Please do not leave or refresh this screen.</p></div>`;
             document.querySelector('.question-wrapper').innerHTML = loadingData;

        const response = await fetch(`${API_BASE_URL}/user-submissions`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "x-site-key": SITE_KEY
            },
            body: JSON.stringify(
                {
                userAnswers,
                userDetails: JSON.parse(sessionStorage.getItem('userDetails'))
            })
        });

        const result = await response.json();
        
        if (result.success) {
           sessionStorage.setItem('reportStatus','completed')
           showAIReport(result.data)
        } else {
            alert('Error saving your data. Please try again.');
            sessionStorage.removeItem("reportStatus")
        }
       
        
    } catch (error) {
        console.error('Error saving user data:', error);
        sessionStorage.removeItem("reportStatus")
        alert('Error saving your data. Please try again.');
    }
}

// Show AI report to user
function showAIReport(userData) {
    
    
    const reportHTML = `
     <!-- Hero -->
  <section class="hero">
    <div class="container">
      <h1>Vastu Report for Your Home</h1>      
    </div>
  </section>

    <!-- How it Works -->
  <section class="how-it-works padd">
    
    <p style="margin-bottom:10px; font-size:16px; font-weight:bold;">Vastu Score For Your Home is</p>
<div class="progress-container">
  <p style="font-size:45px;">${userData.ai_score}%</p>
  <div class="progress-bar">
    <div class="progress-fill" style="width: ${userData.ai_score}%; "></div>
  </div>
</div>
<div id="reportContainer">
   ${userData.ai_report.replace(/\n\n/g, '<br><br>')}
    </div>
  </section>
 `;

//   <div class="report-container">
//             <h2>Your Vastu Analysis Report</h2>
            
//             <div class="score-section">
//                 <h3>Vastu Score: ${userData.ai_score}/100</h3>
//             </div>
            
//             <div class="report-section">
//                 <h3>Detailed Analysis:</h3>
//                 <div class="report-content">
//                     ${userData.ai_report.replace(/\n/g, '<br>')}
//                 </div>
//             </div>
            
//             <div class="actions-section">
//                 <button onclick="showPremiumPlans()" class="btn-premium">
//                     Get Detailed Report
//                 </button>
//             </div>
//         </div>
    
    document.querySelector('.question-wrapper').innerHTML = reportHTML;
    document.querySelector('.plan-section').style.display = 'block';
    initPaymentPage();
}

// start code for plans
async function initPaymentPage() {
    try {
        document.getElementById('plansContainer').innerHTML = '<p>Loading Plans...</p>'
        // Load plans from backend
        const response = await fetch(`${API_BASE_URL}/plans`,
            {
                headers: {
                    "x-site-key": SITE_KEY
                }
            }
        );
        const result = await response.json();
        
        if (result.success) {
            plans = result.data;
            renderPlans();
        } else {
            document.getElementById('plansContainer').innerHTML = `
                <div style="background: #ffe7e7; padding: 20px; border-radius: 5px;">
                    <p>Error loading plans. Please refresh the page.</p>
                </div>
            `;
        }
    } catch (error) {
        console.error('Error loading plans:', error);
        document.getElementById('plansContainer').innerHTML = `
            <div style="background: #ffe7e7; padding: 20px; border-radius: 5px;">
                <p>Error loading plans. Please try again later.</p>
            </div>
        `;
    }
}

// Render plans
function renderPlans() {
 
    
    
    const plansContainer = document.getElementById('plansContainer');

    let plansHtml= `<h2>To get detailed reports of your home choose plan from below</h2>
    <div class="container" style="display:flex; flex-wrap:wrap; justify-content:center; gap:25px;">`;
    
plansHtml += plans.map(plan => 
  plan.type != 'bronze' ? `<div class="plan-card ${plan.type}" style="width:250px;">
    <h4 style="color:var(--vaastu-gold);">${plan.name}</h4>
    <p>Smart analysis powered by traditional wisdom.</p>

    <div class="discount">${plan.discount}% discount</div>
                    <div class="price"><span style="text-decoration: line-through;font-size: 1.2rem;
    font-weight: 600;
    color: #666464;">₹${plan.cut_price}</span><br> ₹${plan.price}</div>

    <a href="#" class="btn btn-warning w-100" onclick="selectPlan('${plan._id}')">Scan Now</a>
    <ul>
      ${plan.features.map(feature => `<li>✓ ${feature}</li>`).join("")}
    </ul>
  </div>` : '').join('');

plansHtml += `</div>`;
plansContainer.innerHTML = plansHtml;

}

function selectPlan(planId) {
    const selectedPlan = plans.find(plan => plan._id === planId);
    
    if (selectedPlan) {
        // Store selected plan in sessionStorage
        sessionStorage.setItem('selected_plan', selectedPlan.type);
        redirectToShopifyCheckout(selectedPlan);
    }
}

function redirectToShopifyCheckout(plan) {
   
    const variantIds = {
        'silver': '51401792553272', 
        'gold': '51401779773752', 
        'platinum': '51401807462712'
    };
    
    const variantId = variantIds[plan.type];
   const sessionId = sessionStorage.getItem("vastu_session_id")
   const PlanType = sessionStorage.getItem("selected_plan")
    
    if (variantId) {
        // Direct checkout link
        window.location.href = `/cart/${variantId}:1?attributes[session_id]=${sessionId}&attributes[plan_type]=${PlanType}`;
    } else {
        alert('Error: Plan not available. Please contact support.');
    }
}

function resendOTP() {
    const mobileNumber = userAnswers.mobile_number;
    alert('OTP resent to ' + mobileNumber);
}

// async function checkMail(){
//     try {
//         const response = await fetch(`${API_BASE_URL}/user-submissions/check-email`, {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json',
//             },
//             body: JSON.stringify({
//                 email: window.CUSTOMER_EMAIL
//             })
//         });

//         let result = await response.json()
//         if(result.success)
//         {
//             alert(result.message)
//             window.location.href ='/'
//         }
//     } catch (error) {
//         console.error('Error while checking mail:', error);
//         alert('Error while checking mail');
//     }
     

// }


document.addEventListener('DOMContentLoaded', async function() {
    // if (window.IS_LOGGED_IN) {
    //     checkMail()
    // console.log("enter");

    // }
    // verify payment received or not

    async function verifyPremiumAccess() {
    try {
        const sessionId = userAnswers.session_id
        const response = await fetch(`${API_BASE_URL}/user-submissions/${sessionId}/payment-status`,
            {
                headers: {
                        "x-site-key": SITE_KEY
                }
            }
        );
        
        
        const result = await response.json();
         PlanType = 'bronze'
         variantId = '52892586017080'
        if(!result.success)
        {
           
            
             window.location.href = `/cart/${variantId}:1?attributes[session_id]=${sessionId}&attributes[plan_type]=${PlanType}`;
             return false
        }
        else if(result.data.plan_type != 'bronze' || result.data.payment_status != 'completed')
        {
           
             window.location.href = `/cart/${variantId}:1?attributes[session_id]=${sessionId}&attributes[plan_type]=${PlanType}`;
             return false
             
        }

    return true;
    }
    catch (error) {
        console.error('Verification error:', error);
        showError('Unable to verify your bronze access.');
        return false;
    }
}
 
          

    if (
    (sessionStorage.getItem('reportStatus') === 'processing' || 
     sessionStorage.getItem('reportStatus') === 'completed') 
    && sessionStorage.getItem('vastu_session_id')
)
     {
        // document.getElementById('mobileVerification').style.display = 'none';
        document.getElementById('questionContainer').style.display = 'block';
        const loadingData= `<div class="report-container">
            <h2>Our expert is analyzing your data. Your personalized vastu report is generating...</h2>
              
                <p class="processing-note">This may take 10-15 minutes.</p>
                <p class="processing-note">Please do not leave or refresh this screen.</p></div>`;
             document.querySelector('.question-wrapper').innerHTML = loadingData;
             const sessionId = sessionStorage.getItem('vastu_session_id');

if (!sessionId) return;

let response = await getUserReport(sessionId);
if(response) return;

if(sessionStorage.getItem('reportStatus') != 'completed')
{
    const interval = setInterval(async () => {

    try {
        const res = await getUserReport(sessionId);

        if (res) {
            
            clearInterval(interval);
        }

    } catch (err) {
        console.error(err);
        clearInterval(interval);
    }

}, 15000);
}


             return;
     }

 let premiumAccess =  await verifyPremiumAccess()
 if(!premiumAccess) return         

    if(sessionStorage.getItem('question'))
{
    window.location.href = '/pages/vastu-premium-questions'
    return;
}

   
    function showError(message) {
    document.getElementById('questionText').textContent = message;
  
}
    

    console.log('Quiz page loaded');
    initQuiz();
    
    // Add event listeners for navigation
    // document.getElementById('nextBtn').addEventListener('click', nextQuestion);
    document.getElementById('prevBtn').addEventListener('click', prevQuestion);
});